import { Divider, Heading, Text } from '@wix/design-system'
import React from 'react'
import Trend from './Trend'
import { AnalyticsResults } from '../models/AnalyticsResults'

interface Props {
    responseResults: AnalyticsResults
}

function AnalyticsHighlights(props: Props) {
    const { responseResults } = props

    return <div className='d-flex' >
        <div className='flex-1 d-flex flex-column'>
            <Text>Net promoter score</Text>
            <div className='d-flex align-items-center'>
                <Heading size='medium' className='me-2'>{responseResults.nps}</Heading>
                <Trend before={responseResults.prevNps} after={responseResults.nps} />

            </div>
        </div>

        <Divider direction="vertical" className='my-4' />


        <div className='flex-1 d-flex flex-column'>
            <Text>Response count</Text>
            <div className='d-flex align-items-center'>
                <Heading size='medium' className='me-2'>{responseResults.items.length}</Heading>
                <Trend before={responseResults.prevItems.length} after={responseResults.items.length} />

            </div>
        </div>
    </div>
}

export default AnalyticsHighlights
